export default __webpack_public_path__ + "static/media/checkin-bed.f9dce2b1.svg";